import { removeUserFromLocalStorage } from "../utils/functions/localStorageManager";
import { loadingState, loadingText } from "../states/loadingState";
import { userState } from "../states/userState";
import { useSetRecoilState, useRecoilState, useResetRecoilState } from "recoil";
import { useState } from "react";
import { sleep } from "../utils/functions/commons";
import { useNavigate } from "react-router-dom";
import { auth } from "../firebase";

export const useLogout = () => {
  const navigation = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const setLoadingAnimation = useSetRecoilState(loadingState);
  const setLoadingText = useSetRecoilState(loadingText);
  const [user, setUser] = useRecoilState(userState);
  const resetUserState = useResetRecoilState(userState);

  const logout = async () => {
    setLoading(true);
    setLoadingAnimation(true);
    setLoadingText("ログアウト中...");
    //setUserToLocalStorage({ ...user, isAuth: false });
    removeUserFromLocalStorage();
    setUser({ ...user, isAuth: false });
    resetUserState();
    await sleep(100);
    auth
      .signOut()
      .then(() => {
        setLoadingAnimation(false);
        setLoadingText("");
        setLoading(false);

        window.location.reload();
      })
      .catch((error) => {
        // サインアウト中のエラーをここで扱う
        setLoading(false);

        console.error("サインアウトエラー: ", error);
        setLoadingAnimation(false);
        setLoadingText("");
      });

    // // navigation("/");
    // resetUserState();
    // removeUserFromLocalStorage();
    // // window.location.reload();
    // removeUserFromLocalStorage();
    // resetUserState();
  };

  return {
    logout,
    loading,
    error,
  };
};
